module.exports = __webpack_public_path__ + "files/b29ddac926642e5083fc7cfca16eba22.png";